import { useState, useEffect } from "react";

// Define la forma del estado que quieres persistir
interface GridLocalStorageState {
    columnOrder?: string[];
    columnVisibilityModel?: Record<string, boolean>;
    pinnedColumns?: {
        left?: string[];
        right?: string[];
    };
    columnWidths?: Record<string, number>; // Clave: nombre de la columna, valor: ancho
}

/**
 * Hook que gestiona la lectura/escritura de la configuración de una tabla en localStorage.
 * @param lsKey key en localStorage
 */
export function useGridLocalStorage(lsKey: string) {
    const [gridState, setGridState] = useState<GridLocalStorageState>({
        columnOrder: [],
        columnVisibilityModel: {},
        pinnedColumns: {},
        columnWidths: {}, // Inicializamos con un objeto vacío
    });

    // 1. Leer de localStorage al montar
    useEffect(() => {
        try {
            const saved = localStorage.getItem(lsKey);
            if (saved) {
                const parsed = JSON.parse(saved) as GridLocalStorageState;
                setGridState(parsed);
            }
        } catch (error) {
            console.error("Error parsing localStorage for key:", lsKey, error);
        }
    }, [lsKey]);

    // 2. Función para guardar cambios en localStorage (y setear estado)
    const saveGridState = (newState: GridLocalStorageState) => {
        setGridState((prevState) => {
            // Si `columnWidths` no está presente en el nuevo estado, lo recuperamos del localStorage
            if (!newState.columnWidths || Object.keys(newState.columnWidths).length === 0) {
                const savedState = localStorage.getItem(lsKey);
                if (savedState) {
                    try {
                        const parsedState = JSON.parse(savedState) as GridLocalStorageState;
                        if (parsedState.columnWidths) {
                            newState = {
                                ...newState,
                                columnWidths: parsedState.columnWidths, // Fusionamos con los widths almacenados
                            };
                        }
                    } catch (error) {
                        console.error("Error al recuperar el estado del localStorage:", error);
                    }
                }
            }
    
            // Verificamos si algo ha cambiado
            const hasChanged =
                JSON.stringify(prevState.columnOrder) !== JSON.stringify(newState.columnOrder) ||
                JSON.stringify(prevState.columnVisibilityModel) !== JSON.stringify(newState.columnVisibilityModel) ||
                JSON.stringify(prevState.pinnedColumns) !== JSON.stringify(newState.pinnedColumns) ||
                JSON.stringify(prevState.columnWidths) !== JSON.stringify(newState.columnWidths); // Comparar los anchos
    
            if (hasChanged) {
                try {
                    localStorage.setItem(lsKey, JSON.stringify(newState));
                } catch (error) {
                    console.error("Error saving grid state to localStorage:", error);
                }
                return newState;
            }
            return prevState;
        });
    };
    


    // 3. Manejador de resize de columnas
    const handleColumnResize = (params: { colDef: { field: string }; width: number }) => {

        console.log(params);
        const field = params.colDef.field; // Nombre de la columna
        const newWidth = params.width; // Nuevo ancho
        setGridState((prev) => {
            const updatedWidths = {
                ...prev.columnWidths,
                [field]: newWidth,
            };
            const updatedState = { ...prev, columnWidths: updatedWidths };

            console.log("mira que es updatedState", updatedState);
            saveGridState(updatedState);
            return updatedState;
        });
    };

    return {
        gridState,
        saveGridState,
        handleColumnResize, // Exportamos el manejador de resize
        lsKey,
    };
}
